import { Text, View } from '@react-pdf/renderer';

interface FiltersProps {
  isFirst: boolean;
  filter: {
    label: string;
    options?: string[];
    value: string[];
    disabled?: boolean;
  };
}

const Filters = ({ filter, isFirst }: FiltersProps) => {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        flex: 1,
        paddingLeft: isFirst ? 0 : '8px',
        borderLeft: isFirst ? 'none' : '1px solid #E8E8E8'
      }}
    >
      <Text style={{ fontSize: '9px', fontWeight: 'light', color: '#5C5C5C' }}>
        {filter.label}
      </Text>

      <Filter filter={filter} />
    </View>
  );
};

const Filter = ({ filter }: { filter: FiltersProps['filter'] }) => {
  if (filter.disabled) {
    return (
      <Text style={{ fontSize: '9px', fontWeight: 'light', color: '#151515' }}>
        —
      </Text>
    );
  }

  if (!filter.options) {
    return (
      <Text style={{ fontSize: '9px', fontWeight: 'light', color: '#151515' }}>
        {filter.value?.[0] ?? ''}
      </Text>
    );
  }

  return (
    <View>
      {filter.options?.map(option => {
        const isSelected = filter.value?.includes(option);

        if (!isSelected) {
          return (
            <Text
              key={option}
              style={{ fontSize: '9px', fontWeight: 'light', color: '#5C5C5C' }}
            >
              {option}
            </Text>
          );
        }

        return (
          <View
            key={option}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <View
              style={{
                width: '4px',
                height: '4px',
                borderRadius: '100%',
                backgroundColor: '#151515'
              }}
            />

            <Text
              style={{ fontSize: '9px', fontWeight: 'light', color: '#151515' }}
            >
              {option}
            </Text>
          </View>
        );
      })}
    </View>
  );
};

export default Filters;
